import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'shared-view-option-chip',
  templateUrl: './view-option-chip.component.html',
  styleUrls: ['./view-option-chip.component.scss'],
  host: { class: 'view-option-chip' },
})
export class SharedViewOptionChipComponent {
  @Input() icon!: string;
  @Input() caption!: string;
  @Input() selected = true;
  @Input() disabled = false;
  @HostBinding('class.disabled') get disabledChecker() {
    return this.disabled == true;
  }
  @HostBinding('class.selected') get selectedChecker() {
    return this.selected == true;
  }
  @HostBinding('class.un-selected') get unselectedChecker() {
    return this.selected == false;
  }

  public replace(input: string, find: string, replace: string): string {
    return input.replace(find, replace);
  }
}
